const formState = {
  name: '',
  additionalMaterialsMain: [],
}
const materialTypes = [
  {
    icon: 'icon',
    label: 'Text Field',
  },
  {
    icon: 'icon',
    label: 'Image',
  },
  {
    icon: 'icon',
    label: 'Video',
  },
  {
    icon: 'icon',
    label: 'Audio',
  },
  {
    icon: 'icon',
    label: 'Document',
  },
  {
    icon: 'icon',
    label: 'Link',
  },
]

const questionsForAllCaseTypes = [
  {
    question: 'Any prior violence committed by the subject?',
    fieldName: 'anyPriorViolence',
  },
  {
    question: 'Any alcohol or drug abuse by subject (including prescription drugs)?',
    fieldName: 'anyAlcoholOrDrug',
  },
  {
    question: 'Has the subject ever been arrested for or convicted of a crime?',
    fieldName: 'everBeenArested',
  },
  {
    question: 'Has a restraining order or protective order ever been issued against the subject?',
    fieldName: 'restrainingOrderOrProtective',
  },
]
const threatQuestions = [
  {
    question: 'Any direct threats (e.g., “I’ll rip your head off”)?  ',
    fieldName: 'directThreats',
  },
  {
    question:
      'Any veiled or indirect threats (e.g., “I know where you live” or “Watch your back”)?',
    fieldName: 'indirectThreats',
  },
  {
    question: 'Any conditional threats (e.g., “If you report this, you’ll regret it.”)?',
    fieldName: 'conditionalThreats',
  },
  {
    question:
      'What media has the subject used to threaten (e.g., in person, telephone, voicemail, text, email, social media, letter)?',
    fieldName: 'whatMedia',
  },
  {
    question: 'Number of threatening communications?',
    fieldName: 'numberOfthreatenings',
  },
  {
    question: 'Date of first threat?',
    fieldName: 'dateOfFirstThreat',
  },
  {
    question: 'Date of most recent threat?',
    fieldName: 'dateOfRecent',
  },
  {
    question: 'What was the threat (verbatim, if possible)?',
    fieldName: 'whatWasTheThreat',
  },
  {
    question: 'Is the threat plausible?',
    fieldName: 'isPlausible',
  },
  {
    question: 'Is the threat specific as to victim, time, and place?',
    fieldName: 'isThreatSpecific',
  },
  {
    question: 'Has the subject threatened others in the past?',
    fieldName: 'hasSubjectBeenThreatened',
  },
  {
    question: 'Does the subject know the victim’s home address?',
    fieldName: 'doesTheSubjectKnows',
  },
  {
    question: 'Have named victims been made aware of the threat?',
    fieldName: 'areVictimsAwate',
  },
  {
    question:
      'Retain, photograph or copy, and upload any physical evidence, such as screenshots or copies of texts, emails, or letters; or audio or video recordings.',
    fieldName: 'retainPhotograph',
  },
]

const vandalismQuestions = [
  {
    question: 'What was vandalized?',
    fieldName: 'whatWasVandalized',
  },
  {
    question:
      'What, if anything, was communicated in the vandalism (e.g., words or images in graffiti)?',
    fieldName: 'comunicatedVandalism',
  },
  {
    question: 'Can it be cleaned up?',
    fieldName: 'canItBeCleandUp',
  },
  {
    question: 'Estimated cost of repairs or replacement?',
    fieldName: 'estimatedCost',
  },
  {
    question: 'Have you uploaded any photos or video of the damage?',
    fieldName: 'anyFilesUploaded',
  },
  {
    question: 'Was there any camera coverage of the vandalism?',
    fieldName: 'anyCameraCoverage',
  },
  {
    question: 'Have any witnesses been identified?',
    fieldName: 'withessesIdentified',
  },
  {
    question:
      'Is there video footage, visitor logs, access logs, or login data that could identify the subject or witnesses?',
    fieldName: 'isThereVideoFootage',
  },
]

const sections: {
  [key: string]: {
    title: string
    questions: { question: string; fieldName: string }[]
  }
} = {
  ALL: {
    title: 'Questions For All Case Types',
    questions: [],
  },
  THREAT: {
    title: 'Questions For Threats',
    questions: threatQuestions,
  },
  VANDALISM: {
    title: 'Questions For Vandalism',
    questions: vandalismQuestions,
  },
  BULLYING: {
    title: 'Questions For Bullying',
    questions: [],
  },
  STALKING: {
    title: 'Questions For Stalking',
    questions: [],
  },
  INTIMATE_PARTNER_VIOLENCE: {
    title: 'Questions For Intimate Partner Violence',
    questions: [],
  },
  WEAPON_ON_COMPANY_PROPERTY: {
    title: 'Questions For Weapon on Company Property',
    questions: [],
  },

  RISK_OF_SELF_HARM: {
    title: 'Questions For Risk of Self-harm',
    questions: [],
  },
  RISK_TO_OTHERS: {
    title: 'Questions For Risk to Others',
    questions: [],
  },
  ASSAULT: {
    title: 'Questions for Assault',
    questions: [],
  },
  CONCERNING_COMMUNICATION: {
    title: 'Questions for Concerning Communication',
    questions: [],
  },
  ANONYMOUS_COMMUNICATION: {
    title: 'Questions for Anonymous Communication',
    questions: [],
  },
  OTHER: {
    title: 'Other',
    questions: [],
  },
}

export default {
  formState,
  materialTypes,
  questionsForAllCaseTypes,
  threatQuestions,
  vandalismQuestions,
  sections,
}
